export default "__VITE_ASSET__54051c7c__"